<script lang="ts">
  import { themes, currentTheme, setTheme, applyTheme, type Theme } from '../stores/theme';

  let open = $state(false);
  let containerEl: HTMLDivElement | undefined = $state();

  function pick(theme: Theme) {
    setTheme(theme);
    applyTheme(theme, true);
    open = false;
  }

  function toggle(e: MouseEvent) {
    e.stopPropagation();
    open = !open;
  }

  function onDocClick(e: MouseEvent) {
    if (open && containerEl && !containerEl.contains(e.target as Node)) {
      open = false;
    }
  }
</script>

<svelte:document onclick={onDocClick} />

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div bind:this={containerEl} class="fixed top-3.5 right-3.5 z-[9999]">
  <!-- Toggle: small accent ring -->
  <button
    onclick={toggle}
    class="w-6 h-6 rounded-full cursor-pointer shadow-md hover:scale-110 hover:shadow-lg"
    style="
      background: {$currentTheme.accent};
      border: 2px solid rgba(255,255,255,0.15);
      box-shadow: 0 0 0 2px {$currentTheme.colors['bg-dark']}, 0 2px 8px rgba(0,0,0,0.3);
    "
    aria-label="Change theme"
    title="Change theme"
  ></button>

  <!-- Dropdown palette -->
  {#if open}
    <div class="absolute top-8 right-0 bg-bg-card border border-border rounded-lg p-1.5 shadow-2xl theme-drop-in min-w-[120px]">
      <div class="grid grid-cols-4 gap-1">
        {#each themes as theme (theme.id)}
          <button
            onclick={() => pick(theme)}
            class="w-6 h-6 rounded-full cursor-pointer hover:scale-110 group relative"
            style="
              background: {theme.accent};
              border: 2px solid {$currentTheme.id === theme.id ? 'white' : 'transparent'};
            "
            aria-label="{theme.name} theme"
            title={theme.name}
          >
            {#if $currentTheme.id === theme.id}
              <span class="absolute inset-0 flex items-center justify-center text-white text-[8px] font-bold drop-shadow">✓</span>
            {/if}
          </button>
        {/each}
      </div>
    </div>
  {/if}
</div>

<style>
  @keyframes drop-in {
    from { opacity: 0; transform: translateY(-4px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  .theme-drop-in {
    animation: drop-in 0.15s ease-out;
    transform-origin: top right;
  }
</style>
